import { Button } from "@msuite/ui/button";
import { TextInput } from "@msuite/ui/form";
import { resolver } from "@msuite/ui/libs/form";
import { Link } from "@msuite/ui/link";
import { useTranslation } from "@msuite/ui/localization";
import { toast } from "@msuite/ui/toast";
import { responseHandler } from "@msuite/ui/utils";
import {
	type IntegratePersonioFormSchema,
	integratePersonioFormSchema,
} from "@msuite/utils/schemas";
import { useForm } from "react-hook-form";
import { client } from "@/hono";
import type { ExtendIntegrationFormProps } from "./types";

export function IntegrationPersonioForm({ refetch }: ExtendIntegrationFormProps) {
	/** Hooks */
	const { t } = useTranslation();
	const methods = useForm({
		resolver: resolver(integratePersonioFormSchema),
	});

	/** Functions */
	async function handleOnSubmit(json: IntegratePersonioFormSchema) {
		try {
			const response = await client.integrations.personio.credentials.$post({ json });
			await responseHandler(response);
			await refetch();
		} catch (error) {
			toast.error(
				error instanceof Error
					? error.message
					: "An error occurred while creating the integration.",
			);
			console.error(error);
		}
	}

	/** Render */
	return (
		<form
			className="v-stack gap-4"
			onSubmit={methods.handleSubmit(handleOnSubmit)}
		>
			<Link
				className="text-xs"
				href="https://support.personio.de/hc/en-us/articles/4404623630993-Generate-and-manage-API-credentials"
			>
				&rsaquo; See API Documentation for custom Personio integrations
			</Link>
			<TextInput
				control={methods.control}
				name="clientId"
				isRequired
				label="Client-ID"
				placeholder="Enter your Personio Client-ID"
				className="font-mono"
				type="password"
			/>
			<TextInput
				control={methods.control}
				name="secret"
				isRequired
				label="Secret"
				placeholder="Enter your Personio Secret"
				className="font-mono"
				type="password"
			/>
			<div className="v-stack gap-1">
				<TextInput
					control={methods.control}
					name="userIdentifier"
					isRequired
					label="User Indetifier"
					placeholder="31539432"
					className="font-mono"
					type="text"
				/>
				<p className="label">
					<span className="opacity-30">https://company-slug.personio.com/staff/details/</span>
					<span className="font-extrabold">12345678</span>
				</p>
			</div>
			<div className="justify-end flex flex-row">
				<Button
					variant="primary"
					isLoading={methods.formState.isSubmitting}
					type="submit"
				>
					{t("general.submit")}
				</Button>
			</div>
		</form>
	);
}
